module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-rechts_red-18357f3af9e74421fe46e3c099aa1926.svg";